export var Theme;
(function (Theme) {
    Theme[Theme["Light"] = 0] = "Light";
    Theme[Theme["Dark"] = 1] = "Dark";
    Theme[Theme["System"] = 2] = "System";
})(Theme || (Theme = {}));
//# sourceMappingURL=IThemesService.js.map